"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInputTestSuite = void 0;
var utils_1 = require("./cypress/support/utils");
var button_tests_1 = require("./cypress/tests/button-tests");
var hour_segment_tests_1 = require("./cypress/tests/hour-segment-tests");
var manual_entry_tests_1 = require("./cypress/tests/manual-entry-tests");
var minute_segment_tests_1 = require("./cypress/tests/minute-segment-tests");
var segement_navigation_tests_1 = require("./cypress/tests/segement-navigation-tests");
var toggle_modes_1 = require("./cypress/tests/toggle-modes");
var event_tests_1 = require("./cypress/tests/event-tests");
var miscellaneous_tests_1 = require("./cypress/tests/miscellaneous-tests");
var IDs_and_labels_1 = require("./src/core/IDs-and-labels");
__exportStar(require("./src/core/index"), exports);
var TimeInputTestSuite = /** @class */ (function () {
    function TimeInputTestSuite(_a) {
        var primaryTestsLabel = _a.primaryTestsLabel, eventTestsLabel = _a.eventTestsLabel, localHostUrl = _a.localHostUrl;
        var IDsAndLabels = (0, IDs_and_labels_1.getIDsAndLabels)({ primaryTestsLabel: primaryTestsLabel, eventTestsLabel: eventTestsLabel });
        this.utils = new utils_1.Utils({ IDsAndLabels: IDsAndLabels, localHostUrl: localHostUrl });
        this.labels = this.utils.labels;
        this.IDs = this.utils.IDs;
        this.tests = new Tests(this.utils);
    }
    return TimeInputTestSuite;
}());
exports.TimeInputTestSuite = TimeInputTestSuite;
var Tests = /** @class */ (function () {
    function Tests(utils) {
        var _this = this;
        this.buttons = new button_tests_1.ButtonTests(utils);
        this.hours = new hour_segment_tests_1.HourSegmentTests(utils);
        this.minutes = new minute_segment_tests_1.MinuteSegmentTests(utils);
        this.mode = new toggle_modes_1.ModeSegmentTests(utils);
        this.manualEntry = new manual_entry_tests_1.ManualEntryTests(utils);
        this.segmentNavigation = new segement_navigation_tests_1.SegmentNavigationTests(utils);
        this.miscellaneous = new miscellaneous_tests_1.MiscellaneousTests(utils);
        this.events = new event_tests_1.EventTests(utils);
        this.all = function () {
            _this.buttons.all();
            _this.hours.all();
            _this.minutes.all();
            _this.mode.all();
            _this.manualEntry.all();
            _this.segmentNavigation.all();
            _this.miscellaneous.all();
            _this.events.all();
        };
    }
    return Tests;
}());
